module.exports = __webpack_public_path__ + "static/media/message-list-not.ff6d77c8.svg";